import React from 'react';
import { Input } from '@/components/ui/input';

interface TextFieldProps {
  label: string;
  required?: boolean;
  value: string;
  onChange: (_value: string) => void;
  placeholder?: string;
  error?: string;
  type?: 'text' | 'email' | 'password';
}

export const TextField: React.FC<TextFieldProps> = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  error,
  type = 'text'
}) => {
  return (
    <>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <Input
        type={type}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        placeholder={placeholder}
        className={error ? 'border-red-500 focus:border-red-500' : ''}
      />
      {error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </>
  );
};
